export default "__VITE_ASSET__DKdyxWF9__"